import Service from '../../Service';
import {http} from '../../config';

export default class FluxoBancarioExtratoService extends Service{

    constructor(){
        super('FluxoBancarioExtrato');
    }

    EnviarDocumento(id, nome, arquivo){
        let bodyFormData = new FormData();
        bodyFormData.append('arquivo', new Blob([arquivo], { type: 'application/pdf' }));

        return http.post(`${this.getNomeControle()}/${id}/documento`, bodyFormData, {
            headers: {'Content-Type': 'multipart/form-data' },
            params: {
                nome
            }
        });
    }

    DeletarDocumento(id, nome){
        return http.delete(`${this.getNomeControle()}/${id}/documento`, {
            params: {
                nome
            }
        });
    }

    DownloadDocumento(id, nome){
        return http.get(`${this.getNomeControle()}/${id}/documento`, {
            responseType: 'blob',
            params: {
                nome
            }
        }).then(res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nome);
            document.body.appendChild(link);
            link.click();
        });
    }
  
}